import React from 'react';
import { Tutorial } from '@lumapps/tutorials/components/Tutorial/lazy';

export const FrontOfficeTutorial = () => <Tutorial  />;
